import React from 'react';
import { useIsFeatureEnabled } from 'src/hooks/useIsFeatureEnabled';
import { FeatureFlag } from 'src/types';
import {
  AtlasLightRootContext,
  AtlasLightThemeProvider,
} from './atlasMuiThemeProvider';

export const AtlasMuiThemeRoot: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const modernizationEnabled = useIsFeatureEnabled(
    FeatureFlag.SPEAK_UP_CASES_MODERNIZATION,
  );

  return (
    <AtlasLightRootContext.Provider value={modernizationEnabled}>
      {modernizationEnabled && <AtlasLightThemeProvider useCssBaseline />}
      {children}
    </AtlasLightRootContext.Provider>
  );
};
